import styled from 'styled-components';
import theme from "../../../theme";

export const LayoutContainer = styled.div`
margin-top: 20px;
	.active {
		color: ${theme.color.brandDark};
		border-bottom: 2px solid ${theme.color.brandDark};
	}
`;

export const TabContainer = styled.div`
	position: sticky;
	top: 0;
	background: #fff;
	z-index: 99;
`;

export const TabNavigationTab = styled.nav`
	border-top: 1px solid #f3f0ff;
	border-bottom: 1px solid #f3f0ff;
	padding: 15px 10px;
	overflow-x: scroll; 

	ul {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}
	li {
		padding: 15px 2%;
		display: inline;
		&:first-child {
			padding-left: 0;
		}
	}
	li a {
		color: #718096;
		padding: 14px 0;
		text-decoration: none;
	}
`;